<template>
    <div class="o-dashboard">
        <c-tabs :tabs="tabs" @select="setTab">

            <c-tab v-if="tab === 'in-progress'">
                <c-table
                    class="c-table--request c-table--request-progress"
                    :columns="columns"
                    :filters="filters"
                    :endpoint="'/api/requests/in-progress/'"
                    :key="'table-in-progress'"></c-table>
            </c-tab>

            <c-tab v-else-if="tab === 'completed'">
                <c-table
                    class="c-table--request c-table--request-completed"
                    :columns="columns"
                    :filters="filters"
                    :endpoint="'/api/requests/completed/'"
                    :key="'table-completed'"></c-table>
            </c-tab>

            <c-tab v-else-if="tab === 'canceled'">
                <c-table
                    class="c-table--request c-table--request-canceled"
                    :columns="columns"
                    :filters="filters"
                    :endpoint="'/api/requests/canceled/'"
                    :key="'table-canceled'"></c-table>
            </c-tab>
        </c-tabs>

        <c-request
            v-show="modal"
            @close="modal=false">
        </c-request>
    </div>
</template>

<script>
import CTable from '@components/table/Container';
import CTabs from '@components/tab/Container';
import CTab from '@components/tab/Element';

import CRequest from '@app/modals/Request';
import View from '@mixins/View';

export default {
    components: { CTable, CTabs, CTab, CRequest },
    mixins: [ View ],
    data() {
        return {
            modal: false,
            tab: 'in-progress',
            tabs: [
                { name:'in-progress', label: 'Lopende aanvragen' },
                { name:'completed', label: 'Afgeronde aanvragen' },
                { name:'canceled', label: 'Geannuleerde aanvragen' }
            ]
        }
    },
    methods: {
        setTab(tab) {
            this.tab = tab;
        },

        openModal() {
            this.modal = true;
        }
    },

    computed: {
        columns() {
            let columns = [
                { name: 'datum', label: 'Datum dienst', sortable: true, component: 'CColumnDate' },
                { name: 'begintijd', label: 'Begintijd', sortable: true, sort: 'asc', component: 'CColumnTime' },
                { name: 'eindtijd', label: 'Eindtijd', sortable: true, component: 'CColumnTime' },
                { name: 'opdrachtgever_naam', label: 'Aanvrager', sortable: true },
                { name: 'naam_gespreksvoerder', label: 'Gespreksvoerder', sortable: true },
                { name: 'kenmerk', label: 'Kenmerk', sortable: true },
                { name: 'taal', label: 'Taal', sortable: true },
                { name: 'naamtolk', label: 'Naam tolk', sortable: true },
                { name: 'telefoontolk', label: 'Telefoonnummer', sortable: true },
                { name: 'status', label: 'Status', component: 'CColumnStatus', sortable: true },
                { name: 'id', label: '', component: 'CColumnButton', props: { route: 'request-detail' }}
            ]

            if ( !this.user.is_planner && !this.user.is_translator ) {
                columns.splice(1,1);
            }

            return columns;
        },
        filters() {

            let applicants = [];

            this.preferences.clients.forEach( (c) => {
                applicants.push({ label: c.user.name, value: c.id });
            });

            let filters = [
                {
                    name: 'is_tolk_opdracht',
                    placeholder: 'Alle diensten',
                    options: [
                        { label: 'Tolkdienst', value: 1},
                        { label: 'Vertaaldienst', value: 0}
                    ]
                },
                {
                    name: 'opdrachtgever_id',
                    placeholder: 'Alle aanvragers',
                    options: applicants
                },
                {
                    name: 'is_urgent',
                    placeholder: 'Alle urgentiestatussen',
                    options: [
                        { label: 'Laag', value: 0},
                        { label: 'Hoog', value: 1},
                        { label: 'Spoed', value: 2}
                    ]
                },
                {
                    name: 'status',
                    placeholder: 'Alle status',
                    options: this.statusses
                },
                {
                    name: 'date',
                    type: 'date',
                    placeholder: 'Datum'
                },
                {
                    name: 'created_at',
                    type: 'date',
                    placeholder: 'Aangevraagd op'
                }
            ];

            if ( !this.user.is_planner && !this.user.is_translator ) {
                filters.splice(1,1);
            }

            return filters;
        },
        statusses() {
            let statusses = [];

            if ( this.preferences.statusses ){
                this.preferences.statusses.forEach( (s) => {
                    if ( s !== 'Afgerond' ) {
                        statusses.push( { label: s, value: s});
                    }
                });
            }

            return statusses;
        }
    },

    created() {
        this.$store.dispatch('listener/on', {
            event: 'toggle-new-request',
            listener: this.openModal
        });
    },

    beforeDestroy() {
        this.$store.dispatch('listener/off', {
            event: 'toggle-new-request',
            listener: this.openModal
        });

    }
}
</script>
